var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateInput',_vm._g(_vm._b({attrs:{"type":_vm.type,"name":_vm.name,"label":_vm.label,"help":_vm.help,"placeholder":_vm.placeholder,"validation":_vm.validation,"error-behavior":_vm.errorBehavior,"value":_vm.value}},'FormulateInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eeb674e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/NxInput.vue
// module id = null
// module chunks = 